import { useEffect, useState } from "react"
import { iAxios } from "../../../lib/utils"
import { useParams } from "react-router"
import moment from 'moment';
import { useDispatch, useSelector } from "react-redux";
import { actionFetchAdminUsers, fetchUserInfo } from "../../../lib/actions";
import classNames from "classnames";
import { GenericForm } from "../../common/GenericForm";

const { Spinner, ModalManager } = require("../../common/Helper")


const UserFromFields = [
    {
        name: 'id',
        required: true,
        type: 'hidden',
    }, {
        name: 'name',
        required: true,
        placeholder: 'Name',
        label: 'Name',
    }, {
        name: 'email',
        required: true,
        label: 'Email Id',
        placeholder: 'Email id'
    }, {
        label: 'Role',
        name: 'role',
        className: 'ds-select',
        element: 'select',
        options: [{
            value: 'Admin',
            label: 'Admin'
        }, {
            value: 'Team Member',
            label: 'Team member'
        }]
    }, {
        name: 'teamLead',
        type: 'email',
        className: 'ds-select',
        label: 'Team Lead Email id',
        element: 'select'
    }, {
        label: 'Start Date',
        name: 'startDate',
        type: 'date',
    }, {
        label: 'End Date',
        name: 'endDate',
        type: 'date',
    }, {
        label: 'Team',
        name: 'team',
        placeholder: 'Enter Team Name'
    }, {
        label: 'Department',
        name: 'department',
        placeholder: 'Enter Department name'
    }, {
        label: 'Designation',
        name: 'designation',
        placeholder: 'Senior Engineer'
    }, 
    {
        label: 'Auto Checkout Config',
        name: 'autoCheckoutSec',
        className: 'ds-select',
        element: 'select',
        options: [{
            value: '-1',
            label: 'Disable App'
        }, {
            value: '1800',
            label: '30 mins'
        },{
            value: '3600',
            label: '1 Hour'
        },{
            value: '7200',
            label: '2 Hours'
        }]
    },
    {
        label: 'Status',
        name: 'status',
        className: 'ds-select',
        element: 'select',
        options: [{
            value: 'Active',
            label: 'Active'
        }, {
            value: 'Inactive',
            label: 'Inactive'
        },{
            value: 'Blocked',
            label: 'Blocked'
        }]
    }, {
        label: 'Handles (Comman Separated)', 
        name: 'handles',
        placeholder: 'Abcd EFG, ijslkn'
    }]

const UserModal = ({ listData }) => {

    const {formData,userInfo} = useSelector(st => ({
        formData: st.modalStatus['userModal'],
        userInfo: st.userInfo
    }));
    
    const [formConfig, setFormConfig] = useState(UserFromFields);
    const dispatch = useDispatch();
    const handleSubmit = (data) => {
        iAxios.post('/api/v1/admin/manage-user',data).then(resp=>{
            if(resp.data.success){
                dispatch(actionFetchAdminUsers());
                dispatch({
                    type: 'hide-modal',
                    name: 'userModal'
                });
                if(data.email === userInfo.email) {
                    dispatch(fetchUserInfo());
                }
            } else {

            }
            
        })
    }

    useEffect(() => {
        if (!formData || !listData) {
            return;
        }

        const excludeList = ['team','handles','autoCheckoutSec']
        const nConf = formConfig.map(element => {
            let ret = {}
            if(element.type === 'hidden'){
                console.log('hidden',element)
                return Object.assign(ret, element);
            }
            if (formData.extUrl?.indexOf("zoho://") >= 0 && !excludeList.includes(element.name)) {
                ret = Object.assign(ret, { disabled: true })
            }
            if (element.name === 'teamLead' && listData) {
                const options = listData
                    .filter(item => item.status === 'Active' && item.email !== formData.email)
                    .map(item => {
                        return {
                            label: item.name,
                            value: item.email
                        }
                    })
                options.push({ label: '', value: '' })
                options.sort((a, b) => a.label.localeCompare(b.label));
                element.options = options;
            }
            return Object.assign(ret, element);
        });
        setFormConfig(nConf);
    }, [listData, formData]);

    return <ModalManager modalName="userModal" title="Manage user" className="ds-modal--wide">
        <h3 style={{ marginBottom: 'var(--ds-space-3)' }}>Manage User</h3>
        {formData?.extUrl?.indexOf("zoho://") >= 0 && <div
            className="ds-badge is-success" style={{ marginBottom: 'var(--ds-space-4)', height: 'auto', padding: 'var(--ds-space-2) var(--ds-space-3)', textTransform: 'none' }}>
            Synced from Zoho — only selected fields can be edited</div>}
        {formData && <GenericForm fields={formConfig}
            wrapClass='ds-form-field'
            onSubmit={handleSubmit}
            initVals={formData}
            formClass='ds-form-grid'
            submitOptions={{ className: 'ds-btn is-primary' }}
            fieldClass='ds-input' />
        }
    </ModalManager>
}

export const Users = () => {
    
    const [users, setUsers] = useState([]);
    const [statusList,setStatusList] = useState([]);
    const [statusFilter, setStatus] = useState('Active');
    const dispatch = useDispatch();

    const data = useSelector(st => st?.apiData?.adminUsers);
 
    const showModal = () => {
        dispatch({
            type: 'show-modal',
            name: 'userModal',
            data: {}
        })
    }
    useEffect(() => {
        dispatch(actionFetchAdminUsers())
    }, [1])

    useEffect(()=>{
        if (!data){
            return;
        }
        const sl = data.reduce((acc,item)=> {
            if (!acc.includes(item.status)){
                acc.push(item.status)
            }
            return acc;
        },[])
        console.log(sl);
        setStatusList(sl.sort())
    },[data])
    useEffect(() => {
        if (!data) {
            return;
        }
        setUsers(data.filter(item => item.status === statusFilter));
    }, [data, statusFilter])
    const editUser = (user) => {
        dispatch({
            type: 'show-modal',
            name: 'userModal',
            data: Object.assign(user, {
                startDate: moment(user.startDate).toDate(),
                endDate: moment(user.endDate).toDate(),
            })
        })
    }
    
    return <div>
        <div className="ds-field-row" style={{ justifyContent: 'space-between', alignItems: 'center' }}>
            <select className="ds-select" style={{ maxWidth: '200px' }} onChange={e => setStatus(e.target.value)} value={statusFilter} aria-label="Status filter">
                {statusList.map(item => <option key={item} value={item}>{item}</option>)}
            </select>
            <button className="ds-btn is-primary" onClick={showModal}>Create user</button>
        </div>
        <div className="ds-panel">
            <div className="ds-table-wrap">
                <table className="ds-table">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Role</th>
                            <th>Team</th>
                            <th>Designation</th>
                            <th>Start Date</th>
                            {statusFilter === 'Active' && <th>Reporting To</th>}
                            {statusFilter !== 'Active' && <th>End Date</th>}
                            <th style={{ width: '60px' }}></th>
                        </tr>
                    </thead>
                    <tbody>
                        {data == null && <tr><td colSpan={9}><Spinner /></td></tr>}
                        {(data && users && users.length === 0) && <tr><td colSpan={9}><div className="issue-empty">List is empty</div></td></tr>}
                        {(data && users) && users.map((item, idx) => <tr key={item.email}>
                            <td className="ds-nums">{idx + 1}</td>
                            <td>{item.name}</td>
                            <td title={`handles: ${item.handles}`}>{item.email}
                                {item.handles && <span className="ds-badge" style={{ marginLeft: '6px' }}>{item.handles?.split(',')?.length}</span>}
                            </td>
                            <td>{item.role}</td>
                            <td>{item.team}</td>
                            <td>{item.designation}</td>
                            <td>{moment(item.startDate).format('DD MMM yyyy')}</td>
                            {statusFilter !== 'Active' && <td>{item.endDate && moment(item.endDate).format('DD MMM YYYY')}</td>}
                            {statusFilter === 'Active' && <td>{item.teamLead}</td>}
                            <td>
                                <button onClick={() => editUser(item)} className="ds-btn is-ghost is-sm">Edit</button>
                            </td>
                        </tr>)}
                    </tbody>
                </table>
            </div>
        </div>
        <UserModal listData={data} />
    </div>;
}